import HttpClienteToken from '../../services/HttpClientToken';

import { PaisProps } from '../../interfaces/catalogos/PaisInterface';

export const Pais = () => {

    return new Promise<PaisProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get('/Api/Pais/', token)
            .then( ({ data } : { data : PaisProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const ObtenerPais = () => {

    return new Promise<PaisProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get('/Api/Pais/ObtenerPais', token)
            .then( ({ data } : { data : PaisProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const ActualizarPais = ( params: PaisProps ) => {

    return new Promise<PaisProps>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/Pais/Actualizar', params, token)
            .then( ({ data } : { data : PaisProps} ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( {
                    idPais: 0,                 
                    descripcion: '',
                    activo: false,     
                });
            });
        }

    });

}

export const AgregarPais = ( params: PaisProps ) => {

    return new Promise<PaisProps>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/Pais/Agregar', params, token)
            .then( ({ data } : { data : PaisProps} ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( {
                    idPais: 0,                   
                    descripcion: '',
                    activo: false,    
                });
            });
        }

    });

}